var EHDI = EHDI || Object.create(null);

EHDI.game = EHDI.game || Object.create(null);

EHDI.game.Effect = function () {
};

EHDI.game.Effect.prototype.init = function (animationPath, armatureName) {
  this._animationPath = animationPath;
  this._textureData;
  this._skeletonData;
  this._textureImage;

  this._factory;
  this._armature;

  this._completeCallback;
  this._completeCallbackEnabled;

  this._animationFactory = EHDI.GetAnimationFactory();

  this._animationFactory.addAnimation(animationPath);

  if (this._skeletonData == null) {
    this._skeletonData = EHDI.Assets.fetch(animationPath + "_ske");
  }

  if (this._factory == null) {
    this._factory = this._animationFactory.getFactory();
  }

  if (this._armature == null) {
    if (armatureName == undefined)
      this._armature = this._factory.buildArmature(this._skeletonData.armature[0].name);
    else
      this._armature = this._factory.buildArmature(armatureName);

    dragonBones.WorldClock.clock.add(this._armature);
  }
};

EHDI.game.Effect.prototype.getArmature = function () {
  return this._armature;
};

EHDI.game.Effect.prototype.changeAnimation = function (loop, animationName) {
  if (animationName == undefined)
    this._armature.animation.gotoAndPlay(this._animationPath,-1,-1,!loop);
  else
    this._armature.animation.gotoAndPlay(animationName,-1,-1,!loop);
};

EHDI.game.Effect.prototype.play = function () {
  this._armature.animation.play();
};

EHDI.game.Effect.prototype.stop = function () {
  this._armature.animation.stop();
};

EHDI.game.Effect.prototype.getDisplay = function () {
  return this._armature.getDisplay();
};

EHDI.game.Effect.prototype.updatePos = function (newX, newY) {
  this._armature.getDisplay().x = newX;
  this._armature.getDisplay().y = newY;
};

EHDI.game.Effect.prototype.addCompleteCallback = function (callback) {
  this._completeCallbackEnabled = true;
  this._completeCallback = callback;
  this._armature.addEventListener('complete', this._handler_onComplete.bind(this));
};

EHDI.game.Effect.prototype._handler_onComplete = function (e) {
  if (this._completeCallback != null)
    this._completeCallback(this);
};

EHDI.game.Effect.prototype.destroy = function () {
  if (this._completeCallbackEnabled) {
    this._armature.removeEventListener('complete', this._handler_onComplete);
    this._completeCallbackEnabled = false;
    this._completeCallback = null;
  }

  if (this._armature != null) {
    if (this._armature.getDisplay().parent != null)
      this._armature.getDisplay().parent.removeChild(this._armature.getDisplay());
    this._armature.animation.stop();
    dragonBones.WorldClock.clock.remove(this._armature);
    this._armature.dispose();
    this._armature = null;
  }

  if (this._factory != null) {
    this._factory = null;
  }

  if (this._skeletonData != null) {
    this._skeletonData = null;
  }

  this._animationPath = null;
  this._animationFactory = null;
}

EHDI.game.Effect.prototype.reset = function () {
  if (this._completeCallbackEnabled) {
    this._armature.removeEventListener('complete', this._handler_onComplete);
    this._completeCallbackEnabled = false;
    this._completeCallback = null;
  }

  if (this._armature != null) {
    this._armature.animation.stop();
    dragonBones.WorldClock.clock.remove(this._armature);

    if (this._armature.getDisplay().parent != null)
      this._armature.getDisplay().parent.removeChild(this._armature.getDisplay());

    this._armature.dispose();
    this._armature = null;
  }

  // if (this._factory != null) {
  //   this._factory.dispose();
  //   this._factory = null;
  // }

  // if (this._textureData != null)
  //   this.textureData = null;

  if (this._skeletonData != null)
    this._skeletonData = null;

  // if (this._textureImage != null)
  //   this._textureImage = null;
};
